export const ocTranslationsEn = {
  OC_RECORDING_NOT_ALLOWED: "Recording is not allowed!",
  OC_EMPLOYEE_REQUESTS: "Employee requests",
  OC_REQUESTS_DETAILS: "Details of requests",
  OC_CONFIRM_GO_BACK_TEXT: "Are you sure you want to back out without saving your data?",
  OC_CONFIRM_GO_BACK: "Confirm undo",
  OC_START_TIME: "Start time",
  OC_END_TIME: "End Time",
  OC_DATE_IN_FUTURE: "The start and end/or dates cannot be later than today!",
  OC_START_DATE_REQUIRED: "Start date is required!",
  OC_END_DATE_REQUIRED: "End date is required!",
  OC_FILTER: "Filter",
  OC_REQUESTS_VIEW: "View requests",
  OC_APPROVE_REQUESTS: "Approve requests",
  OC_END_DATE: "End date",
  OC_START_DATE: "Start date",
  OC_NOT_PROVIDED: "Not provided",
  OC_TEMPORARY_ERROR_TEXT: "Temporary connection problem, please try again later.",
  OC_END_DATE_BEFORE_START_DATE: "The end date must be after the start date!",
  OC_DELETE_CONFIRM: "Confirm deletion",
  OC_UPLOAD_FAILED: "Upload failed",
  OC_FILE_UPLOAD_SIZE_FAILED: "File size is too large (maximum 9MB)",
  OC_DESIGNATION: "Designation",
  OC_INCORRECT_FORMAT: "Incorrect format!",
  OC_ALL_APPROVE: "All approve",
  OC_ALL_APPROVE_FAILED: "Accepting items failed",
  OC_OVERLAPPING_TIME_PERIODS: "Request creation failed due to overlap",
  OC_HOUR: "Hours",
  OC_REQUESTS: "Requests",
  OC_TOO_MANY_HITS: "Too many hits! Please narrow down the conditions!",
  OC_EMPTY: "No fulfilled",
  OC_GENERAL_SETTINGS: "General settings",
  OC_NOTE: "Note",
  OC_ACTIVE: "Active",
  OC_ADD: "Add",
  OC_ALL: "All",
  OC_APPROVE: "Approve",
  OC_CALENDAR: "Calendar",
  OC_CANCEL: "Cancel",
  OC_COMPANY: "Company",
  OC_DELETE: "Delete",
  OC_ERROR_MESSAGE_EMAIL_IS_REQUIRED: "Email filed is required!",
  OC_ERROR_MESSAGE_FIELD_IS_REQUIRED: "Required field!",
  OC_ERROR_TEXT: "An unexpected error occurred while displaying the component.",
  OC_IMAGE: "Image",
  OC_LOADING: "Loading data...",
  OC_MENU: "Menu",
  OC_MODULE: "Module",
  OC_MONTH: "month",
  OC_MONTHS: "months",
  OC_NAME: "Name",
  OC_NEXT: "Next",
  OC_OPTIONAL: "(Optional)",
  OC_ORGUNIT: "Organizational unit",
  OC_JOBCLASSGROUP: "Job class group",
  OC_WORKINGPLACE: "Working place",
  OC_GET_EMPLOYEE: "Employee",
  OC_SHIFT_TYPE: "Shift type",
  OC_PAYOFFICE: "Payoffice",
  OC_PERIOD: "Period",
  OC_PRINT: "Print",
  OC_REJECT: "Reject",
  OC_RELOAD_PAGE: "reload page",
  OC_REQUEST_CREATED_AT: "Request created at",
  OC_REQUEST: "Request",
  OC_ROLE: "Role",
  OC_SAVE: "Save",
  OC_SETTINGS: "Settings",
  OC_STATE: "State",
  OC_TABLE: "Table",
  OC_TO_BE_ASSESSED: "To be assessed",
  OC_TYPE: "Type",
  OC_USER_UPDATED: "Data successfully saved",
  OC_VALID_FROM: "Valid from",
  OC_VALID_TO: "Valid to",
  OC_VALIDITY: "Validity",
  OC_WORKDAYS: "workday(s)",
  OC_YEAR: "year",
  OC_YEARS: "years",
  OC_FILTERING: "Filter",
  OC_COUNT_OF_EMPLOYEES: "Count of employees",
  OC_RESET: "Reset",
  OC_SAVE_FAILED: "An error occured when trying to save data!",
  OC_PROPERTY_SAVE_SUCCEEDED: "Property saved successfully!",
  OC_PROPERTY_SAVE_FAILED: "Saving property failed!",
  OC_REVOKE_REQUEST_CONFIRM: "Are you sure, that you want to revoke your request?",
  OC_ALL_RIGHT: "OK",
  OC_DOWNLOADS: "Downloads",
  OC_ERROR: "Error description",
  OC_CALENDAR_DATE: "Date",
  OC_CALENDAR_TIME: "Time",
  OC_CALENDAR_EVENT: "Event",
  OC_CALENDAR_ALL_DAY: "All day",
  OC_CALENDAR_WEEK: "Week",
  OC_CALENDAR_WORK_WEEK: "Work week",
  OC_CALENDAR_DAY: "Day",
  OC_CALENDAR_MONTH: "Month",
  OC_CALENDAR_PREVIOUS: "Back",
  OC_CALENDAR_NEXT: "Next",
  OC_CALENDAR_YESTERDAY: "Yesterday",
  OC_CALENDAR_TOMORROW: "Tomorrow",
  OC_TODAY: "Today",
  OC_CALENDAR_AGENDA: "Agenda",
  OC_CALENDAR_NO_EVENTS_IN_RANGE: "There are no events in this range.",
  OC_CALENDAR_MORE: "more",
  OC_BACK: "Back",
  OC_FINISH: "Finish",
  OC_AMOUNT: "Amount",
  OC_COST: "Cost",
  OC_NOT_SELECTED: "not selected",
  OC_REFRESH: "Refresh",
  OC_EMPLOYEE_NAME: "Employee's name",
  OC_UPLOAD: "Upload",
  OC_DRAG_AND_DROP_FILE: "Drag and drop or browse",
  OC_CONNECTION_ERROR: "No connection to the server.",
  OC_DB_CONNECTION_ERROR: "There is no connection to the database.",
  OC_DAY: "days",
  OC_DATE: "Date",
  OC_NEW: "New",
  OC_OLD: "Old",
  OC_NO_RESULTS: "No results",
  OC_MESSAGES: "Messages",
  OC_EXAMINERS: "Examiners",
  OC_ROLE_EXAMINERS: "Examiners for this role:",
  OC_ROLE_EDITORS: "Editors for this role:",
  OC_ROLE_ASSIGNERS: "Assigners for this role:",
  OC_MISSING_EXAMINERS: "There is no set examiner",
  OC_MISSING_EDITORS: "There is no set editor",
  OC_MISSING_ASSIGNERS: "There is no set assigner",
  OC_COUNT_OF_REQUESTS: "Count of requests",
  OC_EMPTY_MESSAGE: "Empty message cannot be sent!",
  OC_CONFIRM_SETTING: "Confirm setting",
  OC_CONFIRM_SETTING_INFO: "Are you really changing the setting?",
  OC_MY_ROLES_EXAMINEES: "My role(s) examinees",
  OC_MORE: "More",
  OC_NOT_SET_EXAMINER_INFO: "You do not have a set examiner, so this feature is not available",
  OC_TOTAL_COUNT_OF_EMPLOYEES: "Total count of employees",
  OC_OPERATION_SUCCESSFUL: "Operation successful",
  OC_OPERATION_UNSUCCESSFUL: "Operation unsuccessful",
  OC_MODIFY: "Modify",
  OC_EMPLOYEES: "Employees",
  OC_REQUESTED: "Requested",
  OC_APPROVED: "Approved",
  OC_REJECTED: "Rejected",
  OC_WRITE_MESSAGE: "Write a message...",
  OC_NOT_SELECTABLE: "Not selectable!",
  OC_MESSAGE: "Message",
  OC_SUMMARY: "Summary",
  OC_REMOVE_REQUEST: "Remove",
  OC_REQUESTED_PAST: "Requested",
  OC_ABSENCE: "Absence",
  OC_NAME_REQUIRED: "Name is required!",
  OC_UNSUCCESSFULLY_SAVED: "An error occurred while saving the data(s)!",
  OC_DATE_TOO_FAR_AWAY: "The start and end/or date is too far from today!",
  OC_VIEWS: "View",
  OC_PAGE: "Page",
};
